import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'uvx-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent {

}
